var map = {
	"./daizy_agriculture.jpg": "02de",
	"./daizy_beach.jpg": "3d03",
	"./daizy_bridge.jpg": "acea",
	"./daizy_city.jpg": "d0d7",
	"./daizy_construction.jpg": "68f9",
	"./daizy_docks.jpg": "0af1",
	"./daizy_housing.jpg": "e9b1",
	"./daizy_lulworth.jpg": "b5f9",
	"./daizy_market.jpg": "4611",
	"./daizy_new_forest.jpg": "7019",
	"./daizy_peak.jpg": "df75",
	"./daizy_rail.jpg": "2981",
	"./daizy_river.jpg": "96fd",
	"./daizy_solar.jpg": "b3e1",
	"./daizy_traffic.jpg": "da3d",
	"./daizy_warehouse.jpg": "19b4",
	"./daizy_water.jpg": "ef41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64327";